import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API_URL, postData } from '../../Api';
import {
    MobileInfoBox,
    PanelBox,
    TextView,
    Title,
} from '../../components/Display';
import {
    Button,
    SearchBox,
} from '../../components/Form';
import {
    LeftComponents,
    RightComponents,
    Row,
} from '../../components/Layout';
import {
    TableBody,
    TableColumn,
    TableData,
    TableHeader,
    TableRow,
} from '../../components/Table';

export default function TaroffFinancialShopsBalance(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const buttonExcelClick = () => {
        const queryString = {
            'token': localStorage.getItem('admin_auth_token'),
            'q-title': filterQTitle,
        };
        const url =
            API_URL +
            '/api/panel/page/taroff-financial-shops-balance/export-excel?' +
            new URLSearchParams(queryString).toString();
        window.open(url, '_blank');
    };
    const handlecomp2 = () => {
        applyFilters();
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQTitle('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQTitle && (newSearchParams['q-title'] = filterQTitle);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQTitle, setFilterQTitle] = useState(allProps['q-title'] || '');
    useEffect(() => {
        postData('/api/panel/page/taroff-financial-shops-balance/table-data', {
            size: tableSize,
            page: tablePage,
            q_title: filterQTitle,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>تراز فروشگاه ها</Title>
                </RightComponents>
                <LeftComponents>
                    <Button
                        onClick={buttonExcelClick}
                        color={'secondary'}
                        rightIcon={'fal fa-file-excel'}
                    >
                        اکسل
                    </Button>
                    <Button onClick={handlecomp2} color={'secondary'}>
                        جستجو
                    </Button>
                </LeftComponents>
            </Row>
            <RightComponents wrap={true}>
                <SearchBox onEnter={applyFilters}
                    label={'عنوان'}
                    value={filterQTitle}
                    onChange={setFilterQTitle}
                    width={'120px'}
                />
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>تراز</TableColumn>
                        <TableColumn mobile={false}>زمان ایجاد</TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true} ltr={true} color={ row.text_balance < 0 ? 'red' : 'green' }>{row.text_balance?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-date-normal'}>
                                    {row.text_inserttime}
                                </TextView>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
